<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn" v-if="examType == 0">
      <el-select
        class="select_btn_style"
        v-model="filters.finishStatus"
        placeholder="课件完成情况"
      >
        <el-option
          v-for="(item, i) in finishStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.userAnswerStatus"
        placeholder="考试状态"
      >
        <el-option
          v-for="(item, i) in userAnswerStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item style="margin-left: 22px;">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="学员姓名"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-right: 0px;">
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  props: {
    examType: {
      type: [String, Number],
      default: -1,
    },
  },
  data() {
    return {
      filters: {},
      userAnswerStatusData: [],
      finishStatusData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["USER_ANSWER_STATUS", "FINISH_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_ANSWER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["FINISH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.userAnswerStatusData = res.data["USER_ANSWER_STATUS"];
        this.finishStatusData = res.data["FINISH_STATUS"];
      });
    },
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
